import { jsx as _jsx } from "react/jsx-runtime";
import { FileStatusButton, FileStatusIconProgressing, FileStatusTitle } from "@air/feature-file-status/ui";
import { Close } from "@air/next-icons";
import { memo } from "react";
import { PaneItemTW } from "~/components/FileStatusTrackingPane/PaneItemTW";
export const CopyToWorkspacePanelInProgressPanelItem = /*#__PURE__*/ memo((param)=>{
    let { onCancel, metadata: { targetWorkspaceName } } = param;
    return /*#__PURE__*/ _jsx(PaneItemTW, {
        avatar: /*#__PURE__*/ _jsx(FileStatusIconProgressing, {}),
        title: /*#__PURE__*/ _jsx(FileStatusTitle, {
            children: 'Saving to "'.concat(targetWorkspaceName, '"')
        }),
        buttons: /*#__PURE__*/ _jsx(FileStatusButton, {
            label: "Cancel",
            onClick: ()=>onCancel(),
            children: /*#__PURE__*/ _jsx(Close, {
                className: "size-4"
            })
        })
    });
});
CopyToWorkspacePanelInProgressPanelItem.displayName = "CopyToWorkspacePanelInProgressPanelItem";
